import React from 'react';
import AsyncSelect from 'react-select/async';
import apiGlobal from '../../global/api.global';
import { Label } from 'reactstrap';
import { customStyle } from '../../shared/CommonCSS';

interface Props {
    options: any
    name: string
    label: string
    [x: string]: any
}

const CustomReactSelect = ({ label, options, name, ...props }: Props) => {
    const loadOptions = async () => {
        return apiGlobal.get(`/${props.path}/`)
            .then((response) => {
                return response.data.filter((item: any) => item.display === true)
            })
    }

    return (
        <>
            <Label className='mb-0'>{label}</Label>
            <AsyncSelect
                name={name}
                cacheOptions
                defaultOptions
                getOptionLabel={(e: any) => e[props.field.name]}
                getOptionValue={(e: any) => e.id}
                loadOptions={loadOptions}
                onChange={props.onChange}
                className='mb-3'
                styles={customStyle}
                defaultInputValue={props.defaultValue}
            />
        </>
    )
}

export default CustomReactSelect;